export const DEEEPLINKS = {
  SUPPORT_GENERIC: '/support/generic',
  SUPPORT_LIST: '/support/list',
  SUPPORT_PRINTER_LIST: '/support/printer-list',
  SUPPORT_PRINTER_CONNECTION: '/support/printer-connection',
  UPGRADE: '/support/upgrade'
};
